import { render, staticRenderFns } from "./SelectInputField.vue?vue&type=template&id=039f6386&"
import script from "./SelectInputField.vue?vue&type=script&lang=js&"
export * from "./SelectInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports